import React, { FC, useEffect, useState } from "react"
import { confirmProfileConfirmation } from "../../../common/api/products"
import { LoadingIndicator, Sizes } from "@chr/navisphereonline-shared-components";
import { useParams } from "react-router-dom";
import { ProfileConfirmationNotFound } from "./profile-confirmation-not-found";
import { EmailConfirmationSuccess } from "./email-confirmation-success";
import { EmailPreviouslyConfirmed } from "./email-previously-confirmed";
import { ProfileConfirmation } from "appDtos";

declare type urlParam = {
  guid: string,
  token: string
}

const EmailConfirmationCheck: FC = () => {
  const { guid, token } = useParams() as urlParam;
  const [ profile, setProfile] = useState<ProfileConfirmation>();
  const [ isLoading, setIsloading ] = useState(true);

  useEffect(() => {
    async function confirmEmail(guid:string) {
      try{
        const response = await confirmProfileConfirmation(guid, token);
        if(response) {
          setProfile(response);
        }
      } catch {
        console.error('Email confirmation not found.')
      } finally {
        setIsloading(false);
      }
    }

    if(guid) {
      confirmEmail(guid);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guid]);


  if(isLoading) {
    return <div className="margin-top-20" data-testid="loading-spinner"><LoadingIndicator size={Sizes.Large} /></div>

  } else if(profile && profile.status === "PreviouslyConfirmed" && profile.confirmedDate){
    return <EmailPreviouslyConfirmed confirmedDate={profile.confirmedDate}/>

  } else if(profile && profile.email) {
    return <EmailConfirmationSuccess email={profile.email} />

  } else {
    return <ProfileConfirmationNotFound/>
  }
}

export default EmailConfirmationCheck;
